module.exports = __webpack_public_path__ + "__static/site-1747751661846/img/vector-bg.5d4c4ee9.svg";